<template>
  <div class="reactions-box">
    <div
      v-for="item in reactionTypes"
      :key="item.id" :ref="item.id"
      class="emoji"
      @click.prevent="sendReaction(item.id)"
    >
      <div class="reaction-label">
        <h3 class="no-drag">
          {{ item.label }}
        </h3>
      </div>
      <img class="no-drag" draggable="false" :src="require(`../assets/reactions/${item.id}.png`)">
    </div>
  </div>
</template>

<script>

export default {
  name: 'ReactionsBox',
  data: () => {
    return {
      noSpamActive: false,
      reactionTypes: [
        {
          id: 'love',
          label: 'Love',
        },
        {
          id: 'like',
          label: 'Like',
        },
        {
          id: 'angry',
          label: 'Angry',
        },
        {
          id: 'wow',
          label: 'Wow',
        },
        {
          id: 'sad',
          label: 'Sad',
        },
        {
          id: 'funny',
          label: 'Funny',
        },
      ],
    };
  },

  methods: {
    sendReaction(emojiId){
      if(!this.noSpamActive) {
        this.$emit('send-reaction', emojiId);
      }
      this.noSpamActive = true;
      setTimeout(() => {this.noSpamActive = false;}, 300);
    }
  }
};
</script>

<style scoped>

  .reactions-box {
    display: flex;
    justify-content: center;
    align-content: center;

    width: clamp(22rem, 34vw, 34rem);
    height: clamp(4rem, 7vw, 6rem);
    padding: 0.8rem 2rem;
    border-radius: 60px;

    background-color: #fbfbfb;
    box-shadow: 2px 7px 0px #d5d5d5, 
                inset -2px -2px 0px #ffffff,
                0px 10px 15px #00000071;
    z-index:5;
  }

  .emoji {
    cursor: pointer;

    width: 4.5rem;
    margin: auto clamp(0.1rem, 1vw, 0.3rem);
    transition: 600ms all cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transition-delay: 40ms;

    -webkit-transform-origin: center bottom;
    -moz-transform-origin: center bottom;
    -ms-transform-origin: center bottom;
    -o-transform-origin: center bottom;
    transform-origin: center bottom;
  }
  .emoji:hover {
    transform: translateY(-0.8rem) scale(1.4);
  }

  .emoji:active {
    animation: bounce cubic-bezier(0.175, 0.885, 0.32, 1.275);
    animation-duration: 200ms;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
  }
  @keyframes bounce {
    0%, 100% {
      transform: translateY(-0.8rem) scale(1.3);
    }

    50% {
      transform: translateY(-1.2rem) scale(1.5);
    }
  }


  img {
    width: 100%;
  }

  .reaction-label {
    display: none;
    width: 100%;
  }

  .emoji:hover > .reaction-label {
    display: flex;
    justify-content: center;
    transform: translateY(-1.5rem);
  }

  .reaction-label > h3 {
    position: fixed;
    border-radius: 2rem;
    background-color: #00000060;
    margin: auto;
    padding: 0.2rem 0.5rem;
    font-size: 0.6rem;
    color: white;
  }

</style>
